import { Button } from 'components';
import { useFormikContext } from 'formik';
import { useIsOnlyVisibleToUserWithPermissions } from 'utils/hooks/useIsOnlyVisibleTo';
import { PERMISSION } from 'utils/protectedRoutes/userRolesAndPermissionTypes';

import { useAutosaveContext } from '../context/autosaveContext';
import { NoteFormValues } from '../utils/validation';
import style from '../noteEdit.module.scss';

type SubmitButtonProps = {
  children: string;
  className?: string;
};

export const SubmitButton = ({ children, className }: SubmitButtonProps) => {
  const formik = useFormikContext<NoteFormValues>();
  const { isAutosaving } = useAutosaveContext();
  const canUpdateManagerReview = useIsOnlyVisibleToUserWithPermissions([
    PERMISSION.UPDATE_MANAGER_REVIEW
  ]);

  const isDisabled =
    !formik.isValid ||
    formik.isSubmitting ||
    isAutosaving ||
    (!canUpdateManagerReview && formik.values.noteType === 'MANAGER_REVIEW');

  return (
    <Button
      customStyleClass={className || style.submit}
      theme="primary"
      type="submit"
      disabled={isDisabled}
      text={children}
    />
  );
};
